<p-dialog
  [visible]="visible()"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '991px': '100vw' }"
  [style]="{ width: '760px' }"
  [contentStyle]="{ padding: '0', overflow: 'hidden' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <div class="flex flex-column" style="height: min(85vh, 48rem)">
      <!-- Header -->
      <div
        class="flex-shrink-0 p-3 flex align-items-center justify-content-between border-bottom-1 border-300"
      >
        <div>
          <h4 class="text-base font-normal mb-0">
            {{ 'SUBSCRIPTIONS.PATCH.TITLE' | translate }}
          </h4>
          @if (loadedSubscription(); as sub) {
            <span class="text-sm text-600">
              {{ sub.name_primary_language || sub.name_secondary_language }}
            </span>
          }
        </div>
        <button
          type="button"
          class="p-button p-button-text p-button-rounded"
          (click)="closeDialog()"
          aria-label="close-subscription-patch-dialog"
        >
          <i class="fa fa-times text-xl text-600"></i>
        </button>
      </div>

      <!-- Scrollable body -->
      <div class="flex-1 overflow-y-auto min-h-0">
        @if (isLoading()) {
          <div class="p-4">
            <div class="grid">
              @for (row of [1, 2, 3, 4, 5, 6]; track row) {
                <div class="col-12 md:col-6 mb-3">
                  <p-skeleton width="40%" height="1rem" styleClass="mb-2" />
                  <p-skeleton width="100%" height="2.5rem" />
                </div>
              }
            </div>
          </div>
        } @else if (loadError()) {
          <div class="p-4 text-center">
            <p-message
              severity="error"
              icon="fa fa-exclamation-circle"
              styleClass="w-full"
              aria-label="subscription-patch-load-error"
            >
              {{ 'SUBSCRIPTIONS.PATCH.LOAD_ERROR' | translate }}
            </p-message>
          </div>
        } @else if (loadedSubscription()) {
          <form [formGroup]="patchForm">
            <div class="p-3">
              <p-message
                severity="info"
                icon="fa fa-info-circle"
                styleClass="w-full mb-3"
                aria-label="subscription-patch-info-message"
              >
                {{ 'SUBSCRIPTIONS.PATCH.INFO' | translate }}
              </p-message>

              <!-- Access Control -->
              <section class="mb-4">
                <h5 class="text-sm font-bold mb-3 pb-2 border-bottom-1 border-200">
                  {{ 'SUBSCRIPTIONS.PATCH.SECTION_ACCESS' | translate }}
                </h5>
                <div class="grid">
                  <div class="col-12 md:col-6">
                    <label
                      for="suprema-group-id"
                      class="font-medium text-700 text-xs mb-2 block uppercase"
                    >
                      {{ 'ADMIN.SUBSCRIPTION.ACCESSCONTROL_SUPREMA' | translate }}
                    </label>
                    <input
                      id="suprema-group-id"
                      type="text"
                      pInputText
                      formControlName="suprema_group_id"
                      class="text-sm w-full"
                      aria-label="suprema-group-id-input"
                    />
                  </div>
                  <div class="col-12 md:col-6 flex align-items-end">
                    <div
                      class="flex align-items-center justify-content-between w-full surface-50 border-round p-3"
                    >
                      <span class="text-sm mr-3">
                        {{ 'ADMIN.SUBSCRIPTION.ALLOW_CROSS_TENANT_ACCESS' | translate }}
                      </span>
                      <p-toggleSwitch
                        formControlName="allow_cross_tenant_access"
                        aria-label="allow-cross-tenant-access-switch"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <label
                      for="access-tenant-in"
                      class="font-medium text-700 text-xs mb-2 block uppercase"
                    >
                      {{ 'SUBSCRIPTIONS.PATCH.ACCESS_TENANTS' | translate }}
                    </label>
                    <p-multiSelect
                      inputId="access-tenant-in"
                      formControlName="access_tenant_in"
                      [options]="tenantOptions()"
                      optionLabel="name_primary_language"
                      optionValue="id"
                      [filter]="true"
                      display="chip"
                      styleClass="w-full text-sm"
                      placeholder="{{ 'SUBSCRIPTIONS.PATCH.SELECT_TENANTS' | translate }}"
                      aria-label="access-tenant-in-multiselect"
                    />
                  </div>
                </div>
              </section>

              <!-- Contract & Billing (Recurring only) -->
              @if (isRecurring()) {
                <section class="mb-4">
                  <h5 class="text-sm font-bold mb-3 pb-2 border-bottom-1 border-200">
                    {{ 'SUBSCRIPTIONS.PATCH.SECTION_CONTRACT' | translate }}
                  </h5>
                  <div class="grid">
                    <div class="col-12 md:col-6">
                      <label
                        for="on-contract-expiry"
                        class="font-medium text-700 text-xs mb-2 block uppercase"
                      >
                        {{ 'SUBSCRIPTIONS.PATCH.ON_CONTRACT_EXPIRY' | translate }}
                      </label>
                      <p-select
                        inputId="on-contract-expiry"
                        formControlName="on_contract_expiry"
                        [options]="contractExpiryOptions"
                        optionLabel="label"
                        optionValue="value"
                        styleClass="w-full text-sm"
                        aria-label="on-contract-expiry-select"
                      />
                    </div>
                    <div class="col-12 md:col-6">
                      <label
                        for="break-chrgmst-id"
                        class="font-medium text-700 text-xs mb-2 block uppercase"
                      >
                        {{ 'ADMIN.SUBSCRIPTION.EARLY_CANCELLATION_FEE' | translate }}
                      </label>
                      <p-select
                        inputId="break-chrgmst-id"
                        formControlName="early_cancellation_charge_master_id"
                        [options]="chargeMasters()"
                        optionLabel="name_primary_language"
                        optionValue="id"
                        [filter]="true"
                        filterBy="name_primary_language"
                        styleClass="w-full text-sm"
                        placeholder="{{ 'ADMIN.SUBSCRIPTION.SELECT' | translate }}..."
                        aria-label="break-chrgmst-id-select"
                      />
                    </div>
                    <div class="col-12 md:col-4 flex align-items-center">
                      <div
                        class="flex align-items-center justify-content-between w-full surface-50 border-round p-3"
                      >
                        <span class="text-sm mr-3">{{ 'SUBSCRIPTIONS.AUTO_PAY' | translate }}</span>
                        <p-toggleSwitch
                          formControlName="is_autopay_enabled"
                          aria-label="is-autopay-enabled-switch"
                        />
                      </div>
                    </div>
                    <div class="col-12 md:col-4 flex align-items-center">
                      <div
                        class="flex align-items-center justify-content-between w-full surface-50 border-round p-3"
                      >
                        <span class="text-sm mr-3">
                          {{ 'SUBSCRIPTIONS.PATCH.CASH_RECURRING' | translate }}
                        </span>
                        <p-toggleSwitch
                          formControlName="feature_is_cash_recurring"
                          aria-label="feature-is-cash-recurring-switch"
                        />
                      </div>
                    </div>
                    <div class="col-12 md:col-4 flex align-items-center">
                      <div
                        class="flex align-items-center justify-content-between w-full surface-50 border-round p-3"
                      >
                        <span class="text-sm mr-3">
                          {{ 'ADMIN.SUBSCRIPTION.ALLOW_ONLINE_CANCELLATION' | translate }}
                        </span>
                        <p-toggleSwitch
                          formControlName="feature_is_online_termination_allowed"
                          aria-label="feature-is-online-termination-allowed-switch"
                        />
                      </div>
                    </div>
                  </div>
                </section>
              }

              <!-- Freeze Settings -->
              <section class="mb-4">
                <h5 class="text-sm font-bold mb-3 pb-2 border-bottom-1 border-200">
                  {{ 'SUBSCRIPTIONS.FREEZE' | translate }}
                </h5>
                <div class="grid">
                  <div class="col-12 md:col-6">
                    <label
                      for="freeze-type"
                      class="font-medium text-700 text-xs mb-2 block uppercase"
                    >
                      {{ 'SUBSCRIPTIONS.PATCH.FREEZE_TYPE' | translate }}
                    </label>
                    <p-select
                      inputId="freeze-type"
                      formControlName="freeze_type"
                      [options]="freezeTypeOptions"
                      optionLabel="label"
                      optionValue="value"
                      styleClass="w-full text-sm"
                      aria-label="freeze-type-select"
                    />
                  </div>
                  <div class="col-12 md:col-6">
                    <label
                      for="freeze-attempts"
                      class="font-medium text-700 text-xs mb-2 block uppercase"
                    >
                      {{ 'SUBSCRIPTIONS.FREEZING-ATTEMPTS' | translate }}
                    </label>
                    <p-inputNumber
                      inputId="freeze-attempts"
                      formControlName="freeze_allowed_number_of_attempts_in_year"
                      [min]="0"
                      styleClass="w-full"
                      inputStyleClass="w-full text-sm"
                      aria-label="freeze-allowed-attempts-input"
                    />
                  </div>
                  <div class="col-12 md:col-6">
                    <label
                      for="freeze-min-days"
                      class="font-medium text-700 text-xs mb-2 block uppercase"
                    >
                      {{ 'SUBSCRIPTIONS.PATCH.FREEZE_MIN_DAYS' | translate }}
                    </label>
                    <p-inputNumber
                      inputId="freeze-min-days"
                      formControlName="freeze_min_days_per_instance"
                      [min]="0"
                      styleClass="w-full"
                      inputStyleClass="w-full text-sm"
                      aria-label="freeze-min-days-input"
                    />
                  </div>
                  <div class="col-12 md:col-6">
                    <label
                      for="freeze-max-days"
                      class="font-medium text-700 text-xs mb-2 block uppercase"
                    >
                      {{ 'SUBSCRIPTIONS.PATCH.FREEZE_MAX_DAYS' | translate }}
                    </label>
                    <p-inputNumber
                      inputId="freeze-max-days"
                      formControlName="freeze_max_days_per_instance"
                      [min]="0"
                      styleClass="w-full"
                      inputStyleClass="w-full text-sm"
                      aria-label="freeze-max-days-input"
                    />
                  </div>
                  @if (isRecurring()) {
                    <div class="col-12 md:col-6 flex align-items-center">
                      <div
                        class="flex align-items-center justify-content-between w-full surface-50 border-round p-3"
                      >
                        <span class="text-sm mr-3">
                          {{ 'SUBSCRIPTIONS.FULL-BILLING-CYCLE' | translate }}
                        </span>
                        <p-toggleSwitch
                          formControlName="freeze_can_only_billing_cycle"
                          aria-label="freeze-can-only-billing-cycle-switch"
                        />
                      </div>
                    </div>
                  }
                </div>
              </section>

              <!-- Transfer & Upgrade -->
              <section class="mb-4">
                <h5 class="text-sm font-bold mb-3 pb-2 border-bottom-1 border-200">
                  {{ 'SUBSCRIPTIONS.TRANSFER' | translate }}
                </h5>
                <div class="grid">
                  <div class="col-12 md:col-4 flex align-items-center">
                    <div
                      class="flex align-items-center justify-content-between w-full surface-50 border-round p-3"
                    >
                      <span class="text-sm mr-3">{{ 'SUBSCRIPTIONS.PATCH.TRANSFERABLE' | translate }}</span>
                      <p-toggleSwitch
                        formControlName="transferable"
                        aria-label="transferable-switch"
                      />
                    </div>
                  </div>
                  <div class="col-12 md:col-4">
                    <label
                      for="min-days-transfer"
                      class="font-medium text-700 text-xs mb-2 block uppercase"
                    >
                      {{ 'SUBSCRIPTIONS.PATCH.MIN_DAYS_TRANSFER' | translate }}
                    </label>
                    <p-inputNumber
                      inputId="min-days-transfer"
                      formControlName="min_days_req_for_transfer"
                      [min]="0"
                      styleClass="w-full"
                      inputStyleClass="w-full text-sm"
                      aria-label="min-days-transfer-input"
                    />
                  </div>
                  <div class="col-12 md:col-4">
                    <label
                      for="upgrade-allowed-days"
                      class="font-medium text-700 text-xs mb-2 block uppercase"
                    >
                      {{ 'SUBSCRIPTIONS.PATCH.UPGRADE_ALLOWED_DAYS' | translate }}
                    </label>
                    <p-inputNumber
                      inputId="upgrade-allowed-days"
                      formControlName="upgrade_allowed_days"
                      [min]="0"
                      styleClass="w-full"
                      inputStyleClass="w-full text-sm"
                      aria-label="upgrade-allowed-days-input"
                    />
                  </div>
                </div>
              </section>

              <!-- Guest Pass & Limits -->
              <section class="mb-2">
                <h5 class="text-sm font-bold mb-3 pb-2 border-bottom-1 border-200">
                  {{ 'ADMIN.SUBSCRIPTION.GUEST_PASS' | translate }}
                </h5>
                <div class="grid">
                  <div class="col-12 md:col-4">
                    <label
                      for="max-concurrent-guest-pass"
                      class="font-medium text-700 text-xs mb-2 block uppercase"
                    >
                      {{ 'ADMIN.SUBSCRIPTION.MAX_CONCURRENT_GUEST_PASS' | translate }}
                    </label>
                    <p-inputNumber
                      inputId="max-concurrent-guest-pass"
                      formControlName="max_concurrent_guest_pass"
                      [min]="0"
                      styleClass="w-full"
                      inputStyleClass="w-full text-sm"
                      aria-label="max-concurrent-guest-pass-input"
                    />
                  </div>
                  <div class="col-12 md:col-4">
                    <label
                      for="guest-pass-count"
                      class="font-medium text-700 text-xs mb-2 block uppercase"
                    >
                      {{ 'SUBSCRIPTIONS.PATCH.GUEST_PASS_COUNT' | translate }}
                    </label>
                    <p-inputNumber
                      inputId="guest-pass-count"
                      formControlName="guest_pass_count"
                      [min]="0"
                      styleClass="w-full"
                      inputStyleClass="w-full text-sm"
                      aria-label="guest-pass-count-input"
                    />
                  </div>
                  <div class="col-12 md:col-4">
                    <label
                      for="noshow-late-cancel-limit"
                      class="font-medium text-700 text-xs mb-2 block uppercase"
                    >
                      {{ 'SUBSCRIPTIONS.PATCH.NOSHOW_LATE_CANCEL_LIMIT' | translate }}
                    </label>
                    <p-inputNumber
                      inputId="noshow-late-cancel-limit"
                      formControlName="noshow_late_cancel_limit_per_year"
                      [min]="0"
                      styleClass="w-full"
                      inputStyleClass="w-full text-sm"
                      aria-label="noshow-late-cancel-limit-input"
                    />
                  </div>
                </div>
              </section>
            </div>
          </form>
        }
      </div>

      <!-- Footer -->
      <div
        class="flex-shrink-0 flex flex-column sm:flex-row align-items-stretch sm:align-items-center justify-content-between gap-2 px-4 py-3 border-top-1 border-300"
      >
        <button
          pButton
          pRipple
          type="button"
          [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-primary p-button-text text-sm w-full sm:w-auto"
          (click)="closeDialog()"
          aria-label="cancel-subscription-patch"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          [label]="'common.BUTTONS.BTN_CONFIRM' | translate"
          class="p-button-primary text-sm w-full sm:w-auto"
          [loading]="isSubmitting()"
          [disabled]="isLoading() || loadError() || !loadedSubscription()"
          (click)="submitPatch()"
          aria-label="confirm-subscription-patch"
        ></button>
      </div>
    </div>
  </ng-template>
</p-dialog>
